import React, {Component} from 'react';
import Actionbar from "../Common/Actionbar";
import Loading from "../Common/Loading";
import Navbar from "../Common/Navbar";
import { TiInfoLargeOutline} from "react-icons/all";
import API from "../../services/API";

class News extends Component {
    state = {
        news: [],
        isLoaded: false,
    }
    render() {
        return (
            <React.Fragment>
                <Actionbar noBack={0} title='اخبار و اطلاعیه ها'/>
                {
                    !this.state.isLoaded && <Loading/>
                }
                <section className="container mt-2 py-5">
                    {
                        this.state.news.map ((news , index) => {
                            return (
                                <div className="row transaction-item" key={news.id} >

                                    <div className="col-12 mb-3 text-secondary text-small-1">

                                        <span className='title text-primary-color text-big-1'>{news.title} </span>

                                    </div>

                                    <div className="col-1">
                                        <TiInfoLargeOutline  className='text-big-2 text-secondary ' />
                                    </div>
                                    <div className="col-11 text-small-2 fw-bold mt-2 text-white text-justify new-line" >
                                        {news.text}
                                    </div>
                                </div>
                            )
                        })
                    }
                </section>
                <Navbar/>
            </React.Fragment>
        );
    }
    componentDidMount = () => {
        API.getNews()
            .then((response) => {
                // console.log(response)
                this.setState({isLoaded: true, 'news': response.news})
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
    }
}

export default News;